<template>
  <div style="position: fixed;z-index:1; width: 880px;">
    <div
      v-for="(expense, expenseIndex) in expenses"
      :key="'memory-preview-expense-' + expenseIndex"
    >
      <div
        class="flex justify-between border-bottom border-blue w-full h-fit mt-6"
      >
        <span class="text-blue text-lg font-bold">
          経費{{ expenseIndex + 1 }}/{{ expenses.length }}
        </span>
        <span class="flex flex-row text-blue">
          <div>
            <!-- 総支出 -->
            <span>{{ makeProratedText(expense) }}</span>
            <span class="mx-0.5">/</span>
            <span class="h-fit text-lg font-bold">総</span>
            <span class="text-sm font-bold">支出</span>
            <span class="text-lg font-bold">{{ totalExpensesText }}</span>
          </div>
        </span>
      </div>
      <AppTable v-bind="$attrs" class="ml-3 mr-3 w-full">
        <template v-slot:table-body>
          <!-- 基本情報 -->
          <tr
            v-for="(title, headerIndex) in getBasicHeader(expense.type[0].id)"
            :key="expenseIndex + '-memory-preview-basic-header-' + headerIndex"
            class="flex border border-collapse border-dashed border-blue border-t-0 border-l-0 border-r-0 h-10"
            style="height:auto;"
          >
            <td
              class="mt-2 items-center justify-center"
              style="width:30px; position: relative; top:3px;"
              v-if="currentPoliticalAction.memory.option.viewType == 4"
            >
              <approved-icn width="20" height="20" />
            </td>
            <td
              class="mt-2 items-center justify-center"
              style="width:30px; position: relative; top:3px;"
              v-else-if="currentPoliticalAction.memory.option.viewType === 1"
            >
              <approved-icn class="status-green" width="20" height="20" />
            </td>
            <td
              class="mt-2 items-center justify-center"
              style="width:30px; position: relative;"
              v-else
            >
              <rejected-icn
                v-if="
                  ((currentPoliticalAction.memory.option.viewType === 7 ||
                    currentPoliticalAction.memory.option.viewType === 3) &&
                    sentBackTitle().includes(
                      getAttr(title)
                        .split(/(?=[A-Z])/)
                        .join('_')
                        .toLowerCase() +
                        (expenseIndex + 1),
                    )) ||
                    rejectComment(getAttr(title), expenseIndex + 1)
                "
                class="mb-1"
                width="20"
                height="20"
              />
              <wait-yellow-icn v-else width="20" height="20" />
            </td>
            <td class="mt-2 items-center justify-center" width="150px">
              <span class="text-lg text-blue font-bold">{{ title }}</span>
            </td>
            <td class="mt-2 items-center justify-center">
              <AppPreviewSentBackItem
                color="blue"
                :message="
                  getSentBackItemMessage(
                    getAttr(title)
                      .split(/(?=[A-Z])/)
                      .join('_')
                      .toLowerCase() +
                      (expenseIndex + 1),
                  )
                "
              />
              <div
                v-if="rejectComment(getAttr(title), expenseIndex + 1)"
                class="flex flex-row items-center"
              >
                <rejected-icn
                  class="mt-1.5 mr-1"
                  style="display: inline-block;"
                  width="16"
                  height="16"
                />
                <span
                  class="text-lg mt-1"
                  style="width: 590px; white-space: normal; align-items: center;"
                >
                  {{ rejectComment(getAttr(title), expenseIndex + 1) }}<br />
                </span>
              </div>
              <span class="text-lg">
                <template v-if="title === '項目種別'">
                  {{ makeTypeText(expense.type) }}
                </template>
                <template
                  v-else-if="
                    title === '経路' &&
                      [1, 2, 3, 5].includes(expense.type[0].id)
                  "
                >
                  {{ makeTransportationText(expense) }}
                </template>
                <template
                  v-else-if="
                    title === '人数' && [1, 3, 5].includes(expense.type[0].id)
                  "
                >
                  {{ expense?.people ?? 0 }}人
                </template>
                <template
                  v-else-if="
                    title === '距離' && [2].includes(expense.type[0].id)
                  "
                >
                  {{ expense?.distance ?? 0 }}Km
                </template>
                <template
                  v-else-if="
                    title === '宿泊人数/日数' &&
                      [5].includes(expense.type[0].id)
                  "
                >
                  {{ makeStayingText(expense) }}
                </template>
                <template
                  v-else-if="
                    title === '1人あたりの料金' &&
                      [5].includes(expense.type[0].id)
                  "
                >
                  {{ makeAmountText(expense?.amount) }}
                </template>
                <template
                  v-else-if="
                    title === '明細' && [6].includes(expense.type[0].id)
                  "
                >
                  {{ expense?.detail ?? '' }}
                </template>
                <template
                  v-else-if="
                    title === '費目' && [6].includes(expense.type[0].id)
                  "
                >
                  {{ expense?.item ?? '' }}
                </template>
                <template
                  v-else-if="
                    title === '宿泊詳細' && [4].includes(expense.type[0].id)
                  "
                >
                  {{ expense?.detail ?? '' }}
                </template>
              </span>
            </td>
          </tr>

          <!-- 内容 -->
          <template v-if="expense.receipt">
            <tr
              v-for="(title, contentIndex) in contentHeaders"
              :key="
                expenseIndex + '-memory-preview-basic-header-' + contentIndex
              "
              class="flex border border-collapse border-dashed border-blue border-t-0 border-l-0 border-r-0 h-10"
              style="height:auto;"
            >
              <td
                class="mt-2 items-center justify-center"
                style="width:30px; position: relative; top:3px;"
                v-if="currentPoliticalAction.memory.option.viewType == 4"
              >
                <approved-icn width="20" height="20" />
              </td>
              <td
                class="mt-2 items-center justify-center"
                style="width:30px; position: relative; top:3px;"
                v-else-if="currentPoliticalAction.memory.option.viewType === 1"
              >
                <approved-icn class="status-green" width="20" height="20" />
              </td>
              <td
                class="mt-2 items-center justify-center"
                style="width:30px; position: relative;"
                v-else
              >
                <rejected-icn
                  v-if="
                    ((currentPoliticalAction.memory.option.viewType === 7 ||
                      currentPoliticalAction.memory.option.viewType === 3) &&
                      sentBackTitle().includes(
                        getAttr(title)
                          .split(/(?=[A-Z])/)
                          .join('_')
                          .toLowerCase() +
                          (expenseIndex + 1),
                      )) ||
                      rejectComment(getAttr(title), expenseIndex + 1)
                  "
                  class="mb-1"
                  width="20"
                  height="20"
                />
                <wait-yellow-icn v-else width="20" height="20" />
              </td>
              <td class="mt-2 items-center justify-center" width="150px">
                <span class="text-lg text-blue font-bold">{{ title }}</span>
              </td>
              <td class="mt-2 items-center justify-center">
                <AppPreviewSentBackItem
                  color="blue"
                  :message="
                    getSentBackItemMessage(
                      getAttr(title)
                        .split(/(?=[A-Z])/)
                        .join('_')
                        .toLowerCase() +
                        (expenseIndex + 1),
                    )
                  "
                />
                <div
                  v-if="rejectComment(getAttr(title), expenseIndex + 1)"
                  class="flex flex-row items-center"
                >
                  <rejected-icn
                    class="mt-1.5 mr-1"
                    style="display: inline-block;"
                    width="16"
                    height="16"
                  />
                  <span
                    class="text-lg mt-1"
                    style="width: 590px; white-space: normal; align-items: center;"
                  >
                    {{ rejectComment(getAttr(title), expenseIndex + 1) }}<br />
                  </span>
                </div>
                <template v-if="title === '経費項目'">
                  {{ getExpenseTypeName(expense.receipt?.expenseTypeId) }}
                </template>
                <template v-else-if="title === '支払額'">
                  {{
                    makeAmountText(
                      expense.receipt?.expenseAmount,
                      expense.receipt?.numerator,
                      expense.receipt?.denominator,
                    )
                  }}
                </template>
                <template v-else-if="title === '支払年月日'">
                  {{ makePaymentDateText(expense.receipt.expenseDate) }}
                </template>
                <template v-else-if="title === '支出内容'">
                  {{ expense.receipt?.expenseContent1 }}<br />
                  <span v-if="expense.receipt?.expenseContent2">
                    {{ expense.receipt?.expenseContent2 }}
                  </span>
                </template>
              </td>
            </tr>
          </template>

          <!-- 領収書添付 -->
          <template v-if="expense?.receipt?.images">
            <tr
              class="flex"
              style="height:auto; width:848px"
              v-for="(image, imageIndex) in expense.receipt.images"
              :key="expenseIndex + '-image-' + imageIndex"
            >
              <td
                class="mt-2 items-center justify-center"
                style="width:30px; position: relative; top:3px;"
                v-if="currentPoliticalAction.memory.option.viewType == 4"
              >
                <approved-icn width="20" height="20" />
              </td>
              <td
                class="mt-2 items-center justify-center"
                style="width:30px; position: relative; top:3px;"
                v-else-if="currentPoliticalAction.memory.option.viewType === 1"
              >
                <approved-icn class="status-green" width="20" height="20" />
              </td>
              <td
                class="mt-2 items-center justify-center"
                style="width:30px; position: relative;"
                v-else
              >
                <rejected-icn
                  v-if="
                    ((currentPoliticalAction.memory.option.viewType === 7 ||
                      currentPoliticalAction.memory.option.viewType === 3) &&
                      sentBackTitle().includes('file' + (expenseIndex + 1))) ||
                      rejectComment(getAttr(title), expenseIndex + 1)
                  "
                  class="mb-1"
                  width="20"
                  height="20"
                />
                <wait-yellow-icn v-else width="20" height="20" />
              </td>
              <td class="mt-2" width="150px">
                <span class="text-lg text-blue font-bold">
                  領収書 {{ imageIndex + 1 }}/{{
                    expense.receipt.images.length
                  }}
                </span>
                <br />
              </td>
              <td style="{display:block;width:92%;height:auto;margin:0 auto}">
                <span
                  v-if="currentUser.role_id !== 1"
                  :class="`text-red mb-1 ml-1`"
                  >※画像クリックで黒塗りダイアログが開きます</span
                >
                <img
                  v-if="image.normalImage"
                  :src="
                    image.blackImage == null
                      ? image.normalImage
                      : image.blackImage
                  "
                  @click="
                    openImgPreview('memory', imageIndex, {
                      normalImage: image.normalImage,
                      blackImage: image.blackImage,
                    })
                  "
                />
              </td>
            </tr>
          </template>
        </template>
      </AppTable>
    </div>
  </div>
</template>

<script>
import { computed, getCurrentInstance } from 'vue'
import AppTable from '@/components/ui/AppTable.vue'
import ApprovedIcn from '@/assets/icons/approved.svg?inline'
import RejectedIcn from '@/assets/icons/rejected.svg?inline'
import AppPreviewSentBackItem from '@/components/ui/AppPreviewSentBackItem'
import WaitYellowIcn from '@/assets/icons/wait-yellow.svg?inline'
import { useMemoryReject } from '@/services/politicalActionToda/useMemoryReject'
import { useMemoryForm } from '@/services/politicalAction/useMemoryForm'
import { usePoliticalActions } from '@/services/politicalAction/usePoliticalActions'
import { useDialog } from '@/services/useDialog'
import { useCurrentUser } from '@/services/useCurrentUser'

export default {
  name: 'MemoryPreview',
  components: {
    AppTable,
    ApprovedIcn,
    WaitYellowIcn,
    RejectedIcn,
    AppPreviewSentBackItem,
  },
  setup() {
    const { currentPoliticalAction } = usePoliticalActions()
    const { rejectHeaders, rejectedAttrs } = useMemoryReject()

    /**
     * @var {Map} type(項目種別)と基本情報配列のMap
     */
    const typeToBasicHeaderMap = new Map([
      // 電車
      [1, ['項目種別', '経路', '人数']],
      // 自家用車
      [2, ['項目種別', '経路', '距離']],
      // 飛行機
      [3, ['項目種別', '経路', '人数']],
      // 宿泊費
      [4, ['項目種別', '宿泊詳細']],
      // 宿泊パック
      [5, ['項目種別', '宿泊人数/日数', '1人あたりの料金', '明細']],
      // その他
      [6, ['項目種別', '費目', '明細']],
    ])

    /**
     * @var {Map} receipt.expense_type_idと表示名のMap
     */
    const expenseTypeIdToTitleMap = new Map([
      [1, '調査研究費'],
      [2, '研修費用'],
      [3, '広報費'],
      [4, '公聴費'],
      [5, '要請・陳情活動費'],
      [6, '会議費'],
      [7, '資料作成費'],
      [8, '資料購入費'],
      [9, '人件費'],
      [10, '事務所費'],
    ])

    const contentHeaders = [
      '経費項目',
      '支払額',
      '支払年月日',
      '支出内容',
      '領収書',
    ]

    /**
     * 基本情報リストを取得する
     *
     * @param {number} type expense.type
     * @returns array
     */
    const getBasicHeader = type => {
      return typeToBasicHeaderMap.get(type)
    }

    const expenseTitleToAttrMap = new Map([
      ['項目種別', 'type'],
      ['経路', 'transportation'],
      ['人数', 'people'],
      ['距離', 'distance'],
      ['宿泊人数/日数', 'people/days'],
      ['1人あたりの料金', 'price'],
      ['明細', 'detail'],
      ['費目', 'item'],
      ['宿泊詳細', 'accommodation_details'],
      ['経費項目', 'expense_type'],
      ['支払額', 'expense_amount'],
      ['支払年月日', 'expense_date'],
      ['支出内容', 'expense_content'],
      ['領収書', 'file'],
    ])
    const getAttr = title => {
      return expenseTitleToAttrMap.get(title)
    }

    const expenses = computed(() => {
      return currentPoliticalAction.memory.expenses
    })

    /**
     * @var {number} 支出総額
     */
    const totalExpenses = computed(() => {
      return expenses.value.reduce((total, expense) => {
        const amount = expense?.receipt?.expenseAmount ?? 0
        const numerator = expense?.receipt?.numerator ?? 0
        const denominator = expense?.receipt?.denominator ?? 0
        if (amount === 0) {
          return total
        } else if (numerator === 0 || denominator === 0) {
          return total + amount
        } else {
          return total + prorate(amount, numerator, denominator)
        }
      }, 0)
    })

    /**
     * @var {string} 支出総額。区切り文字付きの文字列
     */
    const totalExpensesText = computed(() => {
      return `${totalExpenses.value.toLocaleString()}円`
    })

    /**
     * 按分する
     *
     * @param {number} amount
     * @param {number} numerator
     * @param {number} denominator
     * @returns number
     */
    const prorate = (amount, numerator, denominator) => {
      return Math.floor((numerator * amount) / denominator)
    }

    /**
     * 項目種別テキストを返す
     *
     * @param {array} type
     * @returns string
     */
    const makeTypeText = type => {
      if (type) {
        return type[0].name
      } else {
        return ''
      }
    }

    /**
     * 按分したテキストを返す
     *
     * @param {object} expense
     * @returns string
     */
    const makeProratedText = expense => {
      const amount = expense?.receipt?.expenseAmount ?? 0
      const numerator = expense?.receipt?.numerator ?? 0
      const denominator = expense?.receipt?.denominator ?? 0
      let proratedAmount = amount
      if (!(amount === 0 || numerator === 0 || denominator === 0)) {
        proratedAmount = prorate(amount, numerator, denominator)
      }
      return `${proratedAmount.toLocaleString()}円`
    }

    /**
     * 交通手段の文字列を作成する\
     * 例: hoge駅 ~ fuga駅 | 往復
     *
     * @param {object} expense
     * @returns string
     */
    const makeTransportationText = expense => {
      const from = expense?.from ?? ''
      const to = expense?.to ?? ''
      const type = expense?.type ?? []
      const isStation = type.length >= 1 ? type[0].id === 1 : false
      const isAirport = type.length >= 1 ? type[0].id === 3 : false
      const isCar = type.length >= 1 ? type[0].id === 2 : false
      if (!(isStation || isAirport || isCar)) {
        console.debug(`expense from or to is invalid. to: ${to}, from: ${from}`)
        return ''
      }
      let location = ''
      if (isStation) {
        location = '駅'
      } else if (isAirport) {
        location = '空港'
      }
      const roundTrip = expense.isRoundTrip ? ' [往復]' : ''
      return `${from}${location} 〜 ${to}${location}${roundTrip}`
    }

    /**
     * 「人数/宿泊日数」の文字列を作成する
     *
     * @param {object} expense
     * @returns string
     */
    const makeStayingText = expense => {
      const people = expense?.people ?? 0
      const stayingDays = expense?.stay_days ?? 0
      return `${people}人 / ${stayingDays}泊`
    }

    /**
     * 数値に桁区切り+円をつけた文字列を返す\
     * 按分指定があれば按分した文字列を返す
     *
     * @param {number} amount 金額
     * @param {number|null} 按分分子
     * @param {number|null} 按分分母
     * @returns string
     */
    const makeAmountText = (amount, numerator = null, denominator = null) => {
      amount = amount ?? 0
      const amountWithComma = amount.toLocaleString()
      if (
        numerator === null ||
        denominator === null ||
        typeof numerator !== 'number' ||
        typeof denominator !== 'number' ||
        numerator < 1 ||
        denominator < 1
      ) {
        return `${amountWithComma}円`
      }

      const proratedAmount = prorate(amount, numerator, denominator)
      const proratedStr = proratedAmount.toLocaleString()
      return `${amountWithComma}円 [${proratedStr}円 按分 ${numerator}/${denominator}]`
    }

    /**
     * 諸経費名を取得する
     *
     * @param {number} expenseTypeId 諸経費項目ID
     */
    const getExpenseTypeName = expenseTypeId => {
      if (!expenseTypeId) {
        return ''
      }
      if (
        !(
          typeof expenseTypeId === 'number' &&
          expenseTypeId >= 1 &&
          expenseTypeId <= 10
        )
      ) {
        throw new Error('expense_type_id is invalid: ' + expenseTypeId)
      }
      return expenseTypeIdToTitleMap.get(expenseTypeId) ?? ''
    }

    /**
     * 支出年月日文字列を取得する\
     * 西暦 | 和暦の形式
     *
     * @param {string} expenseDate 支出年月日
     */
    const makePaymentDateText = expenseDate => {
      if (typeof expenseDate !== 'string') {
        throw new Error('receipt expense date is invalid: ' + expenseDate)
      }
      const app = getCurrentInstance()
      const $filters = app.appContext.config.globalProperties.$filters
      const yearText = $filters.dateFormat(expenseDate)
      const wareki = $filters.wareki(expenseDate)
      return `${yearText} | ${wareki}`
    }

    /**
     * 入力画面で入力した差し戻しコメントを取得する\
     *
     * @param {string} attr 項目名
     * @param {number} index 記録簿のインデックス
     */
    const rejectComment = (attr, index) => {
      let comment = ''
      rejectHeaders.forEach(rejectHeader => {
        if (rejectHeader.attr === attr + index) {
          console.log(rejectHeader.comment)
          comment = rejectHeader.comment
        }
      })
      return comment
    }

    /**
     * 差し戻しコメントが入力されたかどうかを取得する\
     */
    const sentBackTitle = () => {
      if (currentPoliticalAction.memory.sentBackItems.length > 0) {
        const sentBackTitles = []
        currentPoliticalAction.memory.sentBackItems[0].items.forEach(
          sentBackItem => {
            sentBackTitles.push(sentBackItem.target)
          },
        )
        return sentBackTitles
      } else {
        return ''
      }
    }

    return {
      typeToBasicHeaderMap,
      contentHeaders,
      expenses,
      totalExpenses,
      totalExpensesText,
      rejectHeaders,
      rejectedAttrs,
      makeTypeText,
      makeProratedText,
      getBasicHeader,
      getAttr,
      makeTransportationText,
      makeStayingText,
      makeAmountText,
      getExpenseTypeName,
      makePaymentDateText,
      rejectComment,
      sentBackTitle,
      ...useMemoryForm(),
      ...useDialog(),
      ...useCurrentUser(),
    }
  },
}
</script>
<style lang="scss"></style>
